import axios from 'axios'
import router from '@/router'
import {
  Message
} from 'view-design';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 100000
})

// http request 请求拦截器
service.interceptors.request.use(
  config => {
    const AccessToken = sessionStorage.getItem('token')
    if (AccessToken) {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
      config.headers['Token'] = AccessToken
    }
    config.headers['Accept-Token'] = 'SDFWEFSUDYUSSFEF'
    config.headers['User-Time'] = Date.parse(new Date())

    return config
  },
  error => {
    Message.error('请求失败');
    return Promise.reject(error)
  }
)

// http response 响应拦截器
service.interceptors.response.use(

  response => {
    const res = response.data
    if (res.code == -1) {
      Message.error({
        background: true,
        content: res.msg
      });


      router.replace({
        path: '/login',
        query: {
          redirect: router.currentRoute.fullPath
        }
      });
      return
    }
    return response.data;
  },
  error => {
    Message.error('服务器无响应');
    return Promise.reject(error)
  }
)

export default service